export default "__VITE_ASSET__BXauu7Uo__"